import { render, staticRenderFns } from "./seckill-time.vue?vue&type=template&id=98da757c&scoped=true"
import script from "./seckill-time.vue?vue&type=script&lang=js"
export * from "./seckill-time.vue?vue&type=script&lang=js"
import style0 from "./seckill-time.vue?vue&type=style&index=0&id=98da757c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da757c",
  null
  
)

export default component.exports